// Key: mensaje
module.exports = {
  'Failed to fetch': 'No se encuentra el servidor de datos.',
  'NetworkError when attempting to fetch resource.': 'Problemas con la red.',
  'Rows per page:': 'Filas por página'
};



// WEBPACK FOOTER //
// ./src/custom-language-spanish.js